// extracted by mini-css-extract-plugin
export default {"cartItemAttributes":"cartItemAttributes__NDA1N","label":"label__OTUyN","value":"value__MDQ0M","noTextTransform":"noTextTransform__NzlkO"};